export const SORTABLE_SIDEBARS_POC = 'sortable-sidebars';

export default {
  key: SORTABLE_SIDEBARS_POC,
  name: 'Sortable sidebars',
  description: 'Drag, collapse, and reorder the cards on customer, offer, and policy sidebars.'
};
